// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'
import { updatePathValidationsDrawer } from 'redux/modules/pathValidationsDrawer'
import { addPathNumberToHeadings } from './helpers'

const setPathValidationsMessagesInDrawer = (heading, newPathValidations, removeValidations = []) => (dispatch, getState) => {
  const { projectSummary } = getState()

  // if we're within the project summary subtree, we want to add
  // the path indexes to the headings of these validation messages.
  if (projectSummary.get('paths').size) {
    addPathNumberToHeadings(newPathValidations, projectSummary.get('paths'))
  }

  // get the old set of validation messages
  const oldValidations = (
    getState().pathValidationsDrawer
      .get('pathValidations')
  )

  // now any validation objects that should be removed are taken out here.
  // for example, the caller has found no errors/warnings for a given path and
  // so we can remove them from the ValidationsDrawer now.

  // NOTE - adding the 0 here ensures that we clear out any Errors that were previously stored from a failed Path Create.
  // since we're here in the Warnings check, that means we're evaluating messages for paths that have actually been saved.
  const cleanedValidations = [...removeValidations, 0].reduce((a, d) => a.delete(d.toString()), oldValidations)

  // TODO NEXT - make sure this works how we expect it to

  // merges the new validation messages with the old.
  // If newPathValidations contains existing path ids, they will be overridden
  const pathValidations = cleanedValidations.merge(fromJS(newPathValidations))

  // if we have any validation objects or a header,
  // then let's make sure the drawer is open for the user to review.
  const isOpen = !!(heading || pathValidations.size)

  dispatch(updatePathValidationsDrawer({
    heading,
    isOpen,
    pathValidations,
  }))
}

export default setPathValidationsMessagesInDrawer
